// Generated by ts-to-zod
import { z } from "zod";
export const positionSchema = z.union([
    z.literal("HOME"),
    z.literal("AWAY"),
    z.literal("EITHER_SIDE"),
    z.literal("DRAW"),
    z.literal("OVER"),
    z.literal("UNDER"),
    z.literal("LINE"),
    z.literal("SCORE"),
    z.literal("YES"),
    z.literal("NO"),
    z.literal("EXACTLY"),
    z.literal("HOME_HOME"),
    z.literal("HOME_AWAY"),
    z.literal("HOME_DRAW"),
    z.literal("AWAY_HOME"),
    z.literal("AWAY_AWAY"),
    z.literal("AWAY_DRAW"),
    z.literal("DRAW_HOME"),
    z.literal("DRAW_AWAY"),
    z.literal("DRAW_DRAW"),
    z.literal("STRIKE_FOUL"),
    z.literal("BALL_HBP"),
    z.literal("OUT_OTHER"),
    z.literal("SINGLE"),
    z.literal("EXTRA_BASE_HIT"),
    z.literal("DEFENSE"),
    z.literal("DEFENSE_SPECIAL_TEAMS"),
    z.literal("NONE"),
    z.literal("THE_FIELD"),
    z.literal("PLAYERS"),
    z.literal("PITCHERS"),
    z.literal("NO_GOAL"),
    z.literal("SCORE_DRAW"),
]);
export const marketStateSchema = z.union([
    z.literal("PREMATCH"),
    z.literal("INPLAY"),
    z.literal("CLOSED"),
]);
export const dataProviderSchema = z.union([
    z.literal("sportradar"),
    z.literal("SportsDataIO"),
    z.literal("Rotowire"),
    z.literal("DRAFTKINGS"),
    z.literal("FANDUEL"),
    z.literal("BETMGM"),
    z.literal("CAESARS"),
    z.literal("ODDSAPI"),
    z.literal("OUTLIER"),
    z.literal("PS3838"),
    z.literal("FANGRAPHS"),
    z.literal("BASEBALLREFERENCE"),
    z.literal("MLBSTATS"),
    z.literal("BETONLINE"),
    z.literal("BETUS"),
    z.literal("MYBOOKIE"),
    z.literal("SUPERBOOK"),
    z.literal("BETFAIR"),
    z.literal("PRIZEPICKS"),
    z.literal("UNDERDOG"),
    z.literal("ESPNBET"),
    z.literal("NBASTATS"),
    z.literal("BET365"),
    z.literal("CIRCA"),
    z.literal("SLEEPER"),
    z.literal("BETRIVERS"),
    z.literal("FANATICS"),
    z.literal("FLIFF"),
    z.literal("RUNWAY"),
    z.literal("CANNY"),
    z.literal("VSIN"),
    z.literal("OPTA"),
    z.literal("API_SPORTS"),
    z.literal("BOVADA"),
    z.literal("BOOKMAKER"),
    z.literal("SPORTSGAMEODDS"),
    z.literal("PROPHETX"),
    z.literal("NOVIG"),
    z.literal("HARDROCK"),
    z.literal("KALSHI"),
    z.literal("POLYMARKET_INTERNATIONAL"),
    z.literal("BETWAY"),
    z.literal("SKYBET"),
    z.literal("PADDYPOWER"),
    z.literal("WILLIAMHILL"),
    z.literal("LADBROKES_UK"),
    z.literal("CORAL"),
    z.literal("BETFAIR_SB_UK"),
    z.literal("BETFAIR_EX_UK"),
    z.literal("SPORT888"),
    z.literal("SPORTSBET"),
    z.literal("BETFAIR_EX_AU"),
    z.literal("LADBROKES_AU"),
    z.literal("NEDS"),
    z.literal("TAB"),
    z.literal("TABTOUCH"),
    z.literal("UNIBET"),
]);
export const leagueSchema = z.union([
    z.literal("MLB"),
    z.literal("NBA"),
    z.literal("WNBA"),
    z.literal("NCAAMB"),
    z.literal("NFL"),
    z.literal("NCAAFB"),
    z.literal("NHL"),
    z.literal("SOCCER"),
]);
export const leagueCompetitionSchema = z.union([
    z.literal("GBR_EPL"),
    z.literal("ESP_LA_LIGA"),
    z.literal("GER_BUNDESLIGA"),
    z.literal("ITA_SERIE_A"),
    z.literal("FRA_LIGUE_1"),
    z.literal("USA_MLS"),
    z.literal("UEFA_CHAMPIONS"),
    z.literal("UEFA_EUROPA"),
]);
export const sportSchema = z.union([
    z.literal("SOCCER"),
    z.literal("BASEBALL"),
    z.literal("BASKETBALL"),
    z.literal("FOOTBALL"),
    z.literal("ICE_HOCKEY"),
]);
export const propositionSchema = z.union([
    z.literal("TOTAL"),
    z.literal("TOTAL_THREE_WAY"),
    z.literal("MONEYLINE"),
    z.literal("MONEYLINE_THREE_WAY"),
    z.literal("SPREAD"),
    z.literal("SPREAD_THREE_WAY"),
    z.literal("DOUBLE_RESULT"),
    z.literal("WINNING_MARGIN"),
    z.literal("BTTS"),
    z.literal("BTTS_EACH_HALF"),
    z.literal("BLOCKS"),
    z.literal("POINTS_ASSISTS"),
    z.literal("POINTS"),
    z.literal("ASSISTS"),
    z.literal("FANTASY_SCORE_UD"),
    z.literal("FANTASY_SCORE_PP"),
    z.literal("FANTASY_SCORE_SLP"),
    z.literal("GOALS"),
    z.literal("SHOTS_ON_GOAL"),
    z.literal("SHOTS_ON_GOAL_FIRST_FIVE_MINUTES"),
    z.literal("PASSING_ATTEMPTS"),
    z.literal("SAVES"),
    z.literal("SAVES_FIRST_X_SHOTS"),
    z.literal("GOALS_AGAINST"),
    z.literal("DEFENSIVE_TACKLES"),
    z.literal("STEALS_BLOCKS"),
    z.literal("REBOUNDS_ASSISTS"),
    z.literal("REBOUNDS"),
    z.literal("OFFENSIVE_REBOUNDS"),
    z.literal("DEFENSIVE_REBOUNDS"),
    z.literal("POINTS_REBOUNDS_ASSISTS"),
    z.literal("POINTS_REBOUNDS"),
    z.literal("THREE_POINTERS"),
    z.literal("THREE_POINTERS_ATTEMPTED"),
    z.literal("STEALS"),
    z.literal("DOUBLE_DOUBLE"),
    z.literal("TRIPLE_DOUBLE"),
    z.literal("QUADRUPLE_DOUBLE"),
    z.literal("ONE_X_FIVE"),
    z.literal("FIELD_GOALS_ATTEMPTED"),
    z.literal("TURNOVERS"),
    z.literal("FREE_THROWS"),
    z.literal("DUNKS"),
    z.literal("MINUTES_PLAYED"),
    z.literal("PERSONAL_FOULS"),
    z.literal("TWO_POINTERS"),
    z.literal("TWO_POINTERS_ATTEMPTED"),
    z.literal("FREE_THROWS_ATTEMPTED"),
    z.literal("BUZZER_BEATER"),
    z.literal("FIRST_TO_TEN_POINTS"),
    z.literal("POINTS_FIRST_FIVE_MINUTES"),
    z.literal("REBOUNDS_FIRST_FIVE_MINUTES"),
    z.literal("POINTS_REBOUNDS_ASSISTS_FIRST_FIVE_MINUTES"),
    z.literal("POINTS_REBOUNDS_ASSISTS_FIRST_THREE_MINUTES"),
    z.literal("ASSISTS_FIRST_FIVE_MINUTES"),
    z.literal("POINTS_FIRST_THREE_MINUTES"),
    z.literal("REBOUNDS_FIRST_THREE_MINUTES"),
    z.literal("POINTS_NEXT_THREE_MINUTES"),
    z.literal("THREE_POINTERS_FIRST_THREE_MINUTES"),
    z.literal("POINTS_EACH_QUARTER"),
    z.literal("BATTER_STRIKEOUTS"),
    z.literal("STRIKEOUTS"),
    z.literal("HITS_ALLOWED"),
    z.literal("HITS"),
    z.literal("HITS_RUNS_RBIS"),
    z.literal("BASES"),
    z.literal("RUNS"),
    z.literal("HOME_RUNS"),
    z.literal("SINGLES"),
    z.literal("DOUBLES"),
    z.literal("TRIPLES"),
    z.literal("OUTS"),
    z.literal("RBIS"),
    z.literal("STOLEN_BASES"),
    z.literal("EARNED_RUNS_ALLOWED"),
    z.literal("RUNS_ALLOWED"),
    z.literal("WALKS"),
    z.literal("WALKS_ALLOWED"),
    z.literal("PITCHER_WIN"),
    z.literal("HOME_RUNS_STOLEN_BASES"),
    z.literal("PITCHES_THROWN"),
    z.literal("HOME_RUNS_ALLOWED"),
    z.literal("BATTERS_FACED"),
    z.literal("FIRST_PITCH_OF_GAME_STRIKE"),
    z.literal("FIRST_PITCH_OF_GAME_VELOCITY"),
    z.literal("POWERPLAY_POINTS"),
    z.literal("SHOTS_ON_GOAL_BLOCKED_SHOTS"),
    z.literal("GOALIE_SHUTOUTS"),
    z.literal("GOALIE_WIN"),
    z.literal("FACEOFFS_WON"),
    z.literal("TIME_ON_ICE"),
    z.literal("PLUS_MINUS"),
    z.literal("DEFENSIVE_INTERCEPTIONS"),
    z.literal("INTERCEPTIONS_THROWN"),
    z.literal("TOUCHDOWNS"),
    z.literal("TOUCHDOWNS_INCL_PASSING"),
    z.literal("PASSING_TOUCHDOWNS"),
    z.literal("PASSING_YARDS"),
    z.literal("RECEIVING_TOUCHDOWNS"),
    z.literal("RECEIVING_YARDS"),
    z.literal("RECEPTIONS"),
    z.literal("RUSHING_RECEIVING_YARDS"),
    z.literal("PASSING_RUSHING_YARDS"),
    z.literal("RUSHING_TOUCHDOWNS"),
    z.literal("RUSHING_YARDS"),
    z.literal("SACKS"),
    z.literal("LONGEST_RECEPTION"),
    z.literal("LONGEST_RUSH"),
    z.literal("RUSHING_ATTEMPTS"),
    z.literal("LONGEST_PASSING_COMPLETION"),
    z.literal("PASSING_COMPLETIONS"),
    z.literal("PASSING_COMPLETION_PERCENTAGE"),
    z.literal("DEFENSIVE_TACKLES_ASSISTS"),
    z.literal("KICKING_POINTS"),
    z.literal("EXTRA_POINTS"),
    z.literal("MADE_FIELD_GOALS"),
    z.literal("CONSECUTIVE_FIELD_GOALS"),
    z.literal("FIRST_RECEPTION"),
    z.literal("FIRST_RUSH"),
    z.literal("FIRST_PASSING_COMPLETION"),
    z.literal("TOUCHDOWN_YARDS"),
    z.literal("FIELD_GOAL_YARDS"),
    z.literal("FIRST_DOWNS"),
    z.literal("THIRD_DOWN_CONVERSIONS"),
    z.literal("FOURTH_DOWN_CONVERSIONS"),
    z.literal("RECEIVING_TARGETS"),
    z.literal("FUMBLES_LOST"),
    z.literal("PASS_DEFLECTIONS"),
    z.literal("TACKLES_FOR_LOSS"),
    z.literal("PUNTS_INSIDE_20"),
    z.literal("PASSING_TIMES_SACKED"),
    z.literal("PASSING_FIRST_DOWNS"),
    z.literal("OCTOPUS"),
    z.literal("RECEIVING_YARDS_FIRST_TWO_RECEPTIONS"),
    z.literal("RUSHING_YARDS_FIRST_FIVE_ATTEMPTS"),
    z.literal("PASS_COMPLETIONS_FIRST_TEN_ATTEMPTS"),
    z.literal("PASSING_RATING"),
    z.literal("PUNTS"),
    z.literal("PUNTS_AVG_YARDS"),
    z.literal("FIRST_DRIVE_RECEPTIONS"),
    z.literal("TEN_YARD_RECEPTIONS"),
    z.literal("FIFTEEN_YARD_RECEPTIONS"),
    z.literal("TWENTY_YARD_RECEPTIONS"),
    z.literal("THIRTY_YARD_RECEPTIONS"),
    z.literal("FORTY_YARD_RECEPTIONS"),
    z.literal("SHOT_ATTEMPTS"),
    z.literal("RED_CARD"),
    z.literal("CARD_COUNT"),
    z.literal("CARD_COUNT_RED_TWO"),
    z.literal("CARD_POINTS"),
    z.literal("CORNERS"),
    z.literal("CLEARANCES"),
    z.literal("CROSSES"),
    z.literal("FOULS"),
    z.literal("FOULS_DRAWN"),
    z.literal("DRIBBLE_ATTEMPTS"),
    z.literal("GOALS_ASSISTS"),
    z.literal("GOALS_CARD_COUNT"),
    z.literal("KEY_PASSES"),
    z.literal("GOALS_OUTSIDE_BOX"),
    z.literal("HEADER_GOALS"),
    z.literal("TOUCHES"),
    z.literal("HEADER_SHOTS_ON_GOAL"),
    z.literal("SHOTS_ON_GOAL_OUTSIDE_BOX"),
    z.literal("SHOT_ATTEMPTS_EACH_HALF"),
    z.literal("SHOTS_ON_GOAL_EACH_HALF"),
    z.literal("ASSISTS_EACH_HALF"),
    z.literal("GOALS_EACH_HALF"),
    z.literal("FOULS_EACH_HALF"),
    z.literal("GOAL_AND_WIN"),
    z.literal("GOAL_AND_ASSIST"),
    z.literal("OFFSIDES"),
    z.literal("GOALS_AGAINST_FIRST_TEN_MINUTES"),
    z.literal("GOALS_AGAINST_FIRST_NINE_MINUTES"),
    z.literal("GOALS_AGAINST_FIRST_EIGHT_MINUTES"),
    z.literal("GOALS_AGAINST_FIRST_SEVEN_MINUTES"),
    z.literal("GOALS_AGAINST_FIRST_THIRTY_MINUTES"),
    z.literal("GOALS_FIRST_THREE_MINUTES"),
    z.literal("GOALS_NEXT_THREE_MINUTES"),
    z.literal("FIRST_BASKET"),
    z.literal("FIRST_TEAM_BASKET"),
    z.literal("FIRST_TOUCHDOWN"),
    z.literal("LAST_TOUCHDOWN"),
    z.literal("FIRST_TEAM_TOUCHDOWN"),
    z.literal("FIRST_HIT"),
    z.literal("FIRST_HOME_RUN"),
    z.literal("FIRST_TEAM_HOME_RUN"),
    z.literal("FIRST_STOLEN_BASE"),
    z.literal("FIRST_RUN"),
    z.literal("FIRST_RBI"),
    z.literal("FIRST_EARNED_RUN_ALLOWED"),
    z.literal("FIRST_STRIKEOUT"),
    z.literal("FIRST_GOAL"),
    z.literal("SECOND_GOAL"),
    z.literal("THIRD_GOAL"),
    z.literal("FIRST_TEAM_GOAL"),
    z.literal("LAST_GOAL"),
    z.literal("LAST_TEAM_GOAL"),
    z.literal("FIRST_SHOT_ON_GOAL"),
    z.literal("FIRST_FREE_THROW"),
    z.literal("FIRST_THREE_POINTER"),
    z.literal("FIRST_TWO_POINTER"),
    z.literal("FIRST_BLOCK"),
    z.literal("FIRST_REBOUND"),
    z.literal("FIRST_STEAL"),
    z.literal("FIRST_TURNOVER"),
    z.literal("FIRST_ASSIST"),
    z.literal("FIRST_FIELD_GOAL"),
    z.literal("FIRST_TEAM_FIELD_GOAL"),
    z.literal("FIRST_SACK"),
    z.literal("FIRST_TEAM_SACK"),
    z.literal("FIRST_LAST_GOAL"),
    z.literal("FIRST_CARD"),
    z.literal("MOST_TACKLES_ASSISTS"),
    z.literal("MOST_SACKS"),
    z.literal("MOST_POINTS"),
    z.literal("TEAM_MOST_POINTS"),
    z.literal("MOST_REBOUNDS"),
    z.literal("MOST_ASSISTS"),
    z.literal("MOST_THREE_POINTERS"),
    z.literal("MOST_POINTS_REBOUNDS_ASSISTS"),
    z.literal("FIRST_PITCH_RESULT"),
    z.literal("FIRST_TEAM_RECEPTION"),
    z.literal("MOST_PASSING_YARDS"),
    z.literal("MOST_RECEIVING_YARDS"),
    z.literal("MOST_RUSHING_YARDS"),
    z.literal("MOST_RUSHING_RECEIVING_YARDS"),
    z.literal("MOST_SHOTS_ON_GOAL"),
    z.literal("LONGEST_RECEPTION_OF_GAME"),
    z.literal("FIRST_FIELD_GOAL_ATTEMPT"),
    z.literal("FIRST_THREE_POINTER_ATTEMPT"),
]);
export const marketTypeSchema = z.union([
    z.literal("GAMELINE"),
    z.literal("TEAM_PROP"),
    z.literal("PLAYER_PROP"),
    z.literal("GAME_PROP"),
]);
export const propTypeSchema = z.union([
    z.literal("TOTAL"),
    z.literal("TOTAL_THREE_WAY"),
    z.literal("STRAIGHT"),
    z.literal("RELATIVE"),
    z.literal("SPECIAL"),
]);
export const deepLinkSupportSchema = z.union([
    z.literal("MULTI_BET"),
    z.literal("SINGLE_BET"),
    z.literal("EVENT"),
    z.literal("APP"),
]);
export const eventWeatherForecastIconSchema = z.union([
    z.literal("clear-day"),
    z.literal("clear-night"),
    z.literal("cloudy"),
    z.literal("fog"),
    z.literal("partly-cloudy-day"),
    z.literal("partly-cloudy-night"),
    z.literal("rain"),
    z.literal("snow"),
    z.literal("wind"),
]);
export const marketOutcomeSettlementResultSchema = z.union([
    z.literal("WIN"),
    z.literal("LOSS"),
    z.literal("PUSH"),
    z.literal("VOID"),
]);
export const matchupTacticSchema = z.union([
    z.literal("offense"),
    z.literal("defense"),
]);
export const featureSetSchema = z.union([
    z.literal("games"),
    z.literal("propFinder"),
    z.literal("trendingInsights"),
    z.literal("trendingPicks"),
    z.literal("ev"),
    z.literal("boosts"),
    z.literal("arbitrage"),
    z.literal("middle"),
]);
export const injurySeveritySchema = z.union([
    z.literal("OUT"),
    z.literal("UNCERTAIN"),
]);
export const injuryStatusSchema = z.union([
    z.literal("Out"),
    z.literal("Day-to-Day"),
    z.literal("Questionable"),
    z.literal("Probable"),
    z.literal("Doubtful"),
    z.literal("Suspended"),
    z.literal("Out for Season"),
    z.literal("7-Day IL"),
    z.literal("10-Day IL"),
    z.literal("15-Day IL"),
    z.literal("60-Day IL"),
    z.literal("Paternity"),
    z.literal("Bereavement"),
    z.literal("Injured Reserve"),
    z.literal("Game-time Decision"),
    z.literal("Minutes Restriction"),
    z.literal("Maternity"),
]);
export const betResultSchema = z.union([
    z.literal("HITS"),
    z.literal("PUSHES"),
    z.literal("MISSES"),
]);
export const position1Schema = z.union([
    z.literal("HOME"),
    z.literal("AWAY"),
    z.literal("EITHER_SIDE"),
    z.literal("DRAW"),
    z.literal("OVER"),
    z.literal("UNDER"),
    z.literal("LINE"),
    z.literal("SCORE"),
    z.literal("YES"),
    z.literal("NO"),
    z.literal("EXACTLY"),
    z.literal("HOME_HOME"),
    z.literal("HOME_AWAY"),
    z.literal("HOME_DRAW"),
    z.literal("AWAY_HOME"),
    z.literal("AWAY_AWAY"),
    z.literal("AWAY_DRAW"),
    z.literal("DRAW_HOME"),
    z.literal("DRAW_AWAY"),
    z.literal("DRAW_DRAW"),
    z.literal("STRIKE_FOUL"),
    z.literal("BALL_HBP"),
    z.literal("OUT_OTHER"),
    z.literal("SINGLE"),
    z.literal("EXTRA_BASE_HIT"),
    z.literal("DEFENSE"),
    z.literal("DEFENSE_SPECIAL_TEAMS"),
    z.literal("NONE"),
    z.literal("THE_FIELD"),
    z.literal("PLAYERS"),
    z.literal("PITCHERS"),
    z.literal("NO_GOAL"),
    z.literal("SCORE_DRAW"),
]);
export const daysOfRestTypeSchema = z.literal("3IN4");
export const marketGroupSchema = z.union([
    z.literal("GAMELINES"),
    z.literal("GAME"),
    z.literal("X_INNING"),
    z.literal("FIRST_THREE_INNINGS"),
    z.literal("FIRST_FIVE_INNINGS"),
    z.literal("FIRST_SEVEN_INNINGS"),
    z.literal("QUARTERS"),
    z.literal("HALVES"),
    z.literal("PERIODS"),
    z.literal("BATTER_PROPS"),
    z.literal("PITCHER_PROPS"),
    z.literal("OFFENSIVE_PROPS"),
    z.literal("TD_SCORER_PROPS"),
    z.literal("PASSING_PROPS"),
    z.literal("RECEIVING_PROPS"),
    z.literal("RUSHING_PROPS"),
    z.literal("KICKING_PROPS"),
    z.literal("DEFENSIVE_PROPS"),
    z.literal("GENERAL_PROPS"),
    z.literal("FIRST_PROPS"),
    z.literal("FANTASY"),
    z.literal("ATTACKING_PROPS"),
    z.literal("CARDS_FOULS"),
    z.literal("PASSING_DRIBBLING"),
    z.literal("MISCELLANEOUS"),
]);
export const oppRankingFavorabilitySchema = z.union([
    z.literal("FAVORABLE"),
    z.literal("UNFAVORABLE"),
    z.literal("NEUTRAL"),
]);
export const statsMappingFailureTypeSchema = z.union([
    z.literal("ROSTER_TEAM_NOT_MAPPED"),
    z.literal("ROSTER_PLAYER_NOT_MAPPED"),
    z.literal("EVENT_NOT_MAPPED"),
    z.literal("LINEUP_NOT_MAPPED"),
    z.literal("LINEUP_PLAYER_NOT_MAPPED"),
    z.literal("VENUE_NOT_MAPPED"),
]);
export const oddsFormatSchema = z.union([
    z.literal("AMERICAN"),
    z.literal("DECIMAL"),
    z.literal("FRACTIONAL"),
]);
export const kellyDisplaySchema = z.union([
    z.literal("PERCENTAGE_BANKROLL"),
    z.literal("DOLLARS"),
]);
export const linkSetSchema = z.object({
    link: z.string().optional().nullable(),
    deeplink: z.string().optional().nullable(),
    ios_link: z.string().optional().nullable(),
    droid_link: z.string().optional().nullable(),
});
export const coreSummaryStatsSchema = z.record(z.string(), z.unknown()).and(z.object({
    h2h: z.number().optional().nullable(),
    l5: z.number().optional().nullable(),
    l10: z.number().optional().nullable(),
    l20: z.number().optional().nullable(),
    curSeason: z.number().optional().nullable(),
    prevSeason: z.number().optional().nullable(),
    l5Results: z.array(z.boolean().nullable()).optional().nullable(),
    l10Results: z.array(z.boolean().nullable()).optional().nullable(),
}));
export const oddsFractionSchema = z.object({
    numerator: z.number(),
    denominator: z.number(),
});
export const bookIdentifierSchema = z.object({
    bookId: dataProviderSchema,
    bookEventId: z.string(),
    bookMarketId: z.string(),
    bookOutcomeId: z.string(),
    bookProps: z.record(z.string(), z.string()).optional().nullable(),
});
export const marketTeamMetadataSchema = z.record(z.string(), z.unknown()).and(z.object({
    teamId: z.string(),
    name: z.string(),
    alias: z.string(),
    market: z.string().optional().nullable(),
    fullName: z.string().optional().nullable(),
    backgroundHex: z.string().optional().nullable(),
    altHex: z.array(z.string()).optional().nullable(),
    logo: z.string().optional().nullable(),
}));
export const baseModelSchema = z.object({});
export const baseSoccerStatsSchema = z.object({
    xG: z.number(),
    npxG: z.number(),
    xGHeader: z.number(),
    xGOpenPlay: z.number(),
    xGSetPlay: z.number(),
    xGFreeKick: z.number(),
    xGConceded: z.number(),
    npxGConceded: z.number(),
    xGOT: z.number(),
    npxGOT: z.number(),
    xGOTConceded: z.number(),
    npxGOTConceded: z.number(),
    xA: z.number(),
    xASetPlay: z.number(),
    xAOpenPlay: z.number(),
    assists: z.number(),
    goals: z.number(),
    shotsOnGoal: z.number(),
    shotsBlocked: z.number(),
    shotsOffTarget: z.number(),
    shotAttempts: z.number(),
    shotAttemptsSetPiece: z.number(),
    shotsHeader: z.number(),
    shotsOnGoalHeader: z.number(),
    goalsHeader: z.number(),
    shotsObox: z.number(),
    shotsOnGoalObox: z.number(),
    goalsObox: z.number(),
    shotsIbox: z.number(),
    shotsOnGoalIbox: z.number(),
    goalsIbox: z.number(),
    shotsFastbreak: z.number(),
    bigChanceCreated: z.number(),
    bigChanceMissed: z.number(),
    bigChanceScored: z.number(),
    penaltyAttempts: z.number(),
    penaltyGoals: z.number(),
    totalPasses: z.number(),
    accuratePasses: z.number(),
    keyPasses: z.number(),
    keyPassesShotOnGoal: z.number(),
    forwardPasses: z.number(),
    totalPassesFinalThird: z.number(),
    accuratePassesFinalThird: z.number(),
    totalPassesOppHalf: z.number(),
    accuratePassesOppHalf: z.number(),
    totalPassesOwnHalf: z.number(),
    accuratePassesOwnHalf: z.number(),
    finalThirdEntries: z.number(),
    boxEntries: z.number(),
    totalThroughBalls: z.number(),
    accurateThroughBalls: z.number(),
    totalLongBalls: z.number(),
    accurateLongBalls: z.number(),
    totalCrosses: z.number(),
    accurateCrosses: z.number(),
    totalCrossesNoCorner: z.number(),
    accurateCrossesNoCorner: z.number(),
    cornersTaken: z.number(),
    crossesFreeKick: z.number(),
    touches: z.number(),
    touchesInOppBox: z.number(),
    totalDribbleAtt: z.number(),
    wonDribbleAtt: z.number(),
    overruns: z.number(),
    timesTackled: z.number(),
    aerialWon: z.number(),
    aerialLost: z.number(),
    duelWon: z.number(),
    duelLost: z.number(),
    totalClearances: z.number(),
    headClearances: z.number(),
    totalTackles: z.number(),
    wonTackles: z.number(),
    ballRecoveries: z.number(),
    blockedCrosses: z.number(),
    blockedPasses: z.number(),
    blockedShots: z.number(),
    interceptions: z.number(),
    interceptionsInBox: z.number(),
    dangerousPlays: z.number(),
    offsides: z.number().optional(),
});
export const statsSeasonSchema = z.object({
    year: z.string(),
    code: z.string(),
});
export const statsGameScoreSchema = z.object({
    home: z.number(),
    away: z.number(),
});
export const statsTeamSchema = z.object({
    teamId: z.string(),
    name: z.string(),
    alias: z.string(),
    market: z.string().optional().nullable(),
});
export const baseballHittingStatsSchema = z.object({
    strikeouts: z.number(),
    hits: z.number(),
    homeRuns: z.number(),
    singles: z.number(),
    doubles: z.number(),
    triples: z.number(),
    totalBases: z.number(),
    rbis: z.number(),
    runs: z.number(),
    hitsByPitches: z.number(),
    stolenBases: z.number(),
    plateAppearances: z.number(),
    extraBaseHits: z.number(),
    sacFlies: z.number(),
    ppa: z.number(),
    walks: z.number(),
    flyBalls: z.number(),
});
export const baseballParkFactorSplitValueSchema = z.object({
    id: z.string(),
    label: z.string(),
    value: z.string(),
    rank: z.number(),
    num: z.number().optional().nullable(),
    visible: z.boolean().optional().nullable(),
});
export const baseballPeriodPlayerHittingStatsSchema = z.object({
    strikeouts: z.number(),
    hits: z.number(),
    homeRuns: z.number(),
    singles: z.number(),
    doubles: z.number(),
    triples: z.number(),
    totalBases: z.number(),
    extraBaseHits: z.number(),
    rbis: z.number(),
    runs: z.number(),
    hitsByPitches: z.number(),
    stolenBases: z.number(),
    walks: z.number(),
});
export const baseballPeriodPlayerPitchingStatsSchema = z.object({
    totalOutsPitching: z.number(),
    earnedRunsAllowed: z.number(),
    strikeouts: z.number(),
    walks: z.number(),
    hitsAllowed: z.number(),
    pitchesThrown: z.number(),
    runsAllowed: z.number(),
    battersFaced: z.number(),
});
export const baseballPeriodPlayerStatsSchema = z.object({
    stat_type: z.literal("BaseballPlayerPeriodStats").optional(),
    hitting: baseballPeriodPlayerHittingStatsSchema.optional().nullable(),
    pitching: baseballPeriodPlayerPitchingStatsSchema.optional().nullable(),
    reliefPitching: baseballPeriodPlayerPitchingStatsSchema.optional().nullable(),
    fantasyScoreUD: z.number().optional().nullable(),
    fantasyScoreSLP: z.number().optional().nullable(),
    fantasyScorePP: z.number().optional().nullable(),
});
export const baseballPeriodTeamStatsSchema = z.object({
    stat_type: z.literal("BaseballPeriodTeamStats").optional(),
    runs: z.number().optional().nullable(),
    hits: z.number().optional().nullable(),
    homeRuns: z.number().optional().nullable(),
    totalBases: z.number().optional().nullable(),
    rbis: z.number().optional().nullable(),
    batterStrikeouts: z.number().optional().nullable(),
    pitchesThrown: z.number().optional().nullable(),
    errors: z.number().optional().nullable(),
});
export const baseballPitchingStatsSchema = z.object({
    inningsPitched: z.number(),
    totalOutsPitching: z.number(),
    walks: z.number(),
    hitsAllowed: z.number(),
    strikeouts: z.number(),
    pitches: z.number(),
    strikes: z.number(),
    earnedRunsAllowed: z.number(),
    battersFaced: z.number(),
    pitchesThrown: z.number(),
    strikesSwinging: z.number(),
    strikesLooking: z.number(),
    win: z.boolean(),
    qualityStart: z.boolean(),
    runsAllowed: z.number(),
    homeRunsAllowed: z.number(),
});
export const baseballPlayerStatsSchema = z.object({
    hitting: baseballHittingStatsSchema.optional().nullable(),
    pitching: baseballPitchingStatsSchema.optional().nullable(),
    stat_type: z.literal("BaseballPlayerStats").optional(),
    fantasyScoreUD: z.number().optional().nullable(),
    fantasyScoreSLP: z.number().optional().nullable(),
    fantasyScorePP: z.number().optional().nullable(),
    oppStartingPitcherId: z.string().optional().nullable(),
    oppStartingPitcherHand: z.string().optional().nullable(),
    reliefPitching: baseballPitchingStatsSchema.optional().nullable(),
    firstHit: z.boolean().optional().nullable(),
    firstHomeRun: z.boolean().optional().nullable(),
    firstTeamHomeRun: z.boolean().optional().nullable(),
    firstStolenBase: z.boolean().optional().nullable(),
    firstRun: z.boolean().optional().nullable(),
    firstRbi: z.boolean().optional().nullable(),
    firstStrikeout: z.boolean().optional().nullable(),
    firstPitchStrike: z.boolean().optional().nullable(),
    firstPitchSpeed: z.number().optional().nullable(),
});
export const baseballStatsSchema = z.object({
    hitting: baseballHittingStatsSchema.optional().nullable(),
    pitching: baseballPitchingStatsSchema.optional().nullable(),
});
export const baseballTeamStatsSchema = z.object({
    hitting: baseballHittingStatsSchema.optional().nullable(),
    pitching: baseballPitchingStatsSchema.optional().nullable(),
    stat_type: z.literal("BaseballTeamStats").optional(),
    startingPitcherId: z.string().optional().nullable(),
    startingPitcherHand: z.string().optional().nullable(),
});
export const baseballParkFactorSplitSchema = z.object({
    id: z.string(),
    label: z.string(),
    values: z.array(baseballParkFactorSplitValueSchema),
});
export const basketballPeriodStatsSchema = z.object({
    stat_type: z.literal("BasketballPeriodStats").optional(),
    points: z.number(),
    rebounds: z.number(),
    assists: z.number(),
    threePointsMade: z.number(),
    steals: z.number(),
    minutes: z.number().optional().nullable(),
    fantasyScoreUD: z.number().optional().nullable(),
    fantasyScoreSLP: z.number().optional().nullable(),
    fantasyScorePP: z.number().optional().nullable(),
});
export const basketballStatsSchema = z.object({
    stat_type: z.literal("BasketballStats").optional(),
    fantasyScoreUD: z.number().optional().nullable(),
    fantasyScoreSLP: z.number().optional().nullable(),
    fantasyScorePP: z.number().optional().nullable(),
    points: z.number(),
    minutes: z.number(),
    twoPointsAtt: z.number(),
    twoPointsMade: z.number(),
    threePointsAtt: z.number(),
    threePointsMade: z.number(),
    ftAtt: z.number(),
    ftMade: z.number(),
    assists: z.number(),
    rebounds: z.number(),
    offRebounds: z.number(),
    defRebounds: z.number(),
    steals: z.number(),
    blocks: z.number(),
    turnovers: z.number(),
    fouls: z.number(),
    paceFactor: z.number().optional().nullable(),
    dunks: z.number().optional().nullable(),
    firstBasket: z.boolean().optional().nullable(),
    firstTeamBasket: z.boolean().optional().nullable(),
    firstFieldGoal: z.boolean().optional().nullable(),
    firstTeamFieldGoal: z.boolean().optional().nullable(),
    firstFreeThrow: z.boolean().optional().nullable(),
    firstThreePointsMade: z.boolean().optional().nullable(),
    firstTwoPointsMade: z.boolean().optional().nullable(),
    firstBlock: z.boolean().optional().nullable(),
    firstRebound: z.boolean().optional().nullable(),
    firstSteal: z.boolean().optional().nullable(),
    firstTurnover: z.boolean().optional().nullable(),
    firstAssist: z.boolean().optional().nullable(),
    mostPoints: z.boolean().optional().nullable(),
    mostAssists: z.boolean().optional().nullable(),
    mostRebounds: z.boolean().optional().nullable(),
    mostThreePointers: z.boolean().optional().nullable(),
    tsAvailable: z.boolean().optional().nullable(),
    potentialAst: z.number().optional().nullable(),
    rebChances: z.number().optional().nullable(),
});
export const bettingPercentageSchema = z.object({
    position: positionSchema,
    percentage: z.number(),
    money: z.number().optional().nullable(),
});
export const selectionIdsSchema = z.object({
    bookEventId: z.string(),
    bookMarketId: z.string(),
    bookOutcomeId: z.string(),
    bookProps: z.record(z.string(), z.string()).optional().nullable(),
});
export const oddsSchema = z.object({
    american: z.string(),
    decimal: z.number(),
    fraction: oddsFractionSchema,
    maxBet: z.number().optional().nullable(),
});
export const deVigOddsStatisticsSchema = z.object({
    books: z.array(dataProviderSchema),
    normalizedWeights: z.array(z.number()),
    weightedStandardDev: z.number(),
    weightedCoefficientOfVariation: z.number(),
});
export const deeplinkTemplateDtoSchema = z.object({
    support: deepLinkSupportSchema,
    baseTemplate: z.string(),
    baseAdministrativeAreaTemplate: z.string().optional().nullable(),
    selectionTemplate: z.string(),
    selectionSeperator: z.string().optional().nullable(),
    failureMessage: z.string().optional().nullable(),
    pickTerm: z.string().optional().nullable(),
    warningHeadline: z.string().optional().nullable(),
    warningDescription: z.string().optional().nullable(),
});
export const versusTeamSchema = z.object({
    teamId: z.string(),
    name: z.string(),
    alias: z.string(),
    market: z.string().optional().nullable(),
    points: z.string().optional().nullable(),
});
export const baseballBallparkDistancesSchema = z
    .record(z.string(), z.unknown())
    .and(z.object({
    lf: z.number(),
    lcf: z.number(),
    cf: z.number(),
    rcf: z.number(),
    rf: z.number(),
}));
export const eventWeatherHourlyForecastSchema = z
    .record(z.string(), z.unknown())
    .and(z.object({
    datetime: z.string(),
    datetimeLocal: z.string(),
    icon: eventWeatherForecastIconSchema,
    conditions: z.string(),
    description: z.string().optional().nullable(),
    temperatureF: z.number(),
    feelsLikeF: z.number(),
    humidity: z.number(),
    dew: z.number(),
    precipitationProbability: z.number(),
    precipitationTypes: z.array(z.string()).optional().nullable(),
    windSpeed: z.number(),
    windDirection: z.number(),
    windDirectionLabel: z.string().optional().nullable(),
    windDirectionRelative: z.number().optional().nullable(),
    cloudCover: z.number(),
}));
export const featureTogglesSchema = z.object({
    games: z.boolean(),
    propFinder: z.boolean(),
    trendingInsights: z.boolean(),
    trendingPicks: z.boolean(),
    oppRank: z.boolean(),
});
export const footballConversionStatsSchema = z.object({
    passing: z.number(),
    rushing: z.number(),
    receiving: z.number(),
    defensive: z.number(),
});
export const footballDefensiveStatsSchema = z.object({
    interceptions: z.number(),
    sacks: z.number(),
    tackles: z.number(),
    assists: z.number(),
    defendedPasses: z.number(),
    qbHits: z.number(),
    fumbleRecoveries: z.number(),
    safeties: z.number(),
    tacklesForLoss: z.number(),
    battedPasses: z.number().optional().nullable(),
    defTargets: z.number().optional().nullable(),
    defCompletions: z.number().optional().nullable(),
    blitzes: z.number().optional().nullable(),
    hurries: z.number().optional().nullable(),
    knockdowns: z.number().optional().nullable(),
    missedTackles: z.number().optional().nullable(),
});
export const footballExtraPointStatsSchema = z.object({
    attempts: z.number(),
    made: z.number(),
    blocked: z.number(),
});
export const footballFieldGoalStatsSchema = z.object({
    attempts: z.number(),
    made: z.number(),
    blocked: z.number(),
    longest: z.number(),
    att1to39: z.number(),
    att40to49: z.number(),
    att50plus: z.number(),
    made1to39: z.number(),
    made40to49: z.number(),
    made50plus: z.number(),
});
export const footballFumbleStatsSchema = z.object({
    total: z.number(),
    lost: z.number(),
    forced: z.number(),
    ownRecoveredTDs: z.number(),
    oppRecoveredTDs: z.number(),
});
export const footballPassingStatsSchema = z.object({
    yards: z.number(),
    avgYards: z.number(),
    attempts: z.number(),
    completions: z.number(),
    interceptionsThrown: z.number(),
    rating: z.number().optional().nullable(),
    redzoneAttempts: z.number(),
    sacks: z.number().optional().nullable(),
    longestPlay: z.number().optional().nullable(),
    firstDowns: z.number(),
    airYards: z.number().optional().nullable(),
    badThrows: z.number().optional().nullable(),
    droppedPasses: z.number().optional().nullable(),
    defendedPasses: z.number().optional().nullable(),
    battedPasses: z.number().optional().nullable(),
    onTargetThrows: z.number().optional().nullable(),
    hurries: z.number().optional().nullable(),
    avgPocketTime: z.number().optional().nullable(),
});
export const footballPeriodPlayerStatsSchema = z.object({
    stat_type: z.literal("FootballPeriodPlayerStats").optional(),
    touchdowns: z.number(),
    passTDs: z.number(),
    passYds: z.number(),
    rushYds: z.number(),
    recvYds: z.number(),
    receptions: z.number(),
    fieldGoals: z.number(),
    extraPoints: z.number(),
});
export const footballPeriodTeamStatsSchema = z.object({
    stat_type: z.literal("FootballTeamPeriodStats").optional(),
    touchdowns: z.number(),
    fieldGoals: z.number(),
});
export const footballReceivingStatsSchema = z.object({
    targets: z.number(),
    redzoneTargets: z.number(),
    receptions: z.number(),
    yards: z.number(),
    avgYards: z.number(),
    firstDowns: z.number(),
    yardsAfterCatch: z.number().optional().nullable(),
    yardsAfterContact: z.number().optional().nullable(),
    longestPlay: z.number().optional().nullable(),
    airYards: z.number().optional().nullable(),
    brokenTackles: z.number().optional().nullable(),
});
export const footballRushingStatsSchema = z.object({
    yards: z.number(),
    attempts: z.number(),
    longestPlay: z.number().optional().nullable(),
    yardsAfterContact: z.number().optional().nullable(),
    brokenTackles: z.number().optional().nullable(),
    redzoneAttempts: z.number().optional().nullable(),
    firstDowns: z.number(),
});
export const footballTouchdownStatsSchema = z.object({
    first: z.boolean().optional().nullable(),
    scored: z.number(),
    passing: z.number(),
    rushing: z.number(),
    receiving: z.number(),
    puntReturn: z.number().optional().nullable(),
    misc: z.number().optional().nullable(),
    kickReturn: z.number().optional().nullable(),
    interceptionReturn: z.number().optional().nullable(),
    fumbleReturn: z.number().optional().nullable(),
});
export const footballPuntStatsSchema = z.object({
    attempts: z.number(),
    yards: z.number(),
    blocked: z.number(),
    inside20: z.number(),
});
export const footballTeamTotalsSchema = z.object({
    playCount: z.number(),
    rushPlays: z.number(),
    passPlays: z.number(),
    redzoneTargets: z.number(),
    redzoneRushAtt: z.number(),
    airYards: z.number().optional().nullable(),
    touchdowns: z.number(),
    turnovers: z.number(),
    defPassPressures: z.number(),
    defPassPressurePct: z.number(),
});
export const footballStatsSchema = z.object({
    receiving: footballReceivingStatsSchema.optional().nullable(),
    passing: footballPassingStatsSchema.optional().nullable(),
    rushing: footballRushingStatsSchema.optional().nullable(),
    touchdown: footballTouchdownStatsSchema.optional().nullable(),
    fieldGoal: footballFieldGoalStatsSchema.optional().nullable(),
    defense: footballDefensiveStatsSchema.optional().nullable(),
    extraPoint: footballExtraPointStatsSchema.optional().nullable(),
    fumbles: footballFumbleStatsSchema.optional().nullable(),
    conversions: footballConversionStatsSchema.optional().nullable(),
    punts: footballPuntStatsSchema.optional().nullable(),
    teamTotals: footballTeamTotalsSchema.optional().nullable(),
    oppTeamTotals: footballTeamTotalsSchema.optional().nullable(),
});
export const footballTeamStatsSchema = z.object({
    receiving: footballReceivingStatsSchema.optional().nullable(),
    passing: footballPassingStatsSchema.optional().nullable(),
    rushing: footballRushingStatsSchema.optional().nullable(),
    touchdown: footballTouchdownStatsSchema.optional().nullable(),
    fieldGoal: footballFieldGoalStatsSchema.optional().nullable(),
    defense: footballDefensiveStatsSchema.optional().nullable(),
    extraPoint: footballExtraPointStatsSchema.optional().nullable(),
    fumbles: footballFumbleStatsSchema.optional().nullable(),
    conversions: footballConversionStatsSchema.optional().nullable(),
    punts: footballPuntStatsSchema.optional().nullable(),
    teamTotals: footballTeamTotalsSchema.optional().nullable(),
    oppTeamTotals: footballTeamTotalsSchema.optional().nullable(),
    stat_type: z.literal("FootballTeamStats").optional(),
});
export const marketEventMetadataSchema = z.object({
    eventId: z.string(),
    scheduledTime: z.string(),
    home: marketTeamMetadataSchema,
    away: marketTeamMetadataSchema,
    weekId: z.string().optional().nullable(),
    year: z.string(),
    neutralSite: z.boolean().optional().nullable(),
    timezone: z.string().optional().nullable(),
});
export const marketPlayerMetadataSchema = z.object({
    playerId: z.string(),
    teamId: z.string(),
    status: z.string(),
    fullName: z.string(),
    firstName: z.string(),
    lastName: z.string(),
    preferredName: z.string().optional().nullable(),
    position: z.string().optional().nullable(),
    jerseyNumber: z.string().optional().nullable(),
    extraProps: z.record(z.string(), z.unknown()).optional().nullable(),
});
export const bookOddsDtoSchema = z.object({
    american: z.string(),
    decimal: z.number(),
    fraction: oddsFractionSchema,
    book: dataProviderSchema,
    identifier: selectionIdsSchema,
    maxBet: z.number().optional().nullable(),
});
export const marketOutcomeSummaryStatsSchema = z.object({
    awaySummaryStat: coreSummaryStatsSchema.optional().nullable(),
    homeSummaryStat: coreSummaryStatsSchema.optional().nullable(),
    playerSummaryStat: coreSummaryStatsSchema.optional().nullable(),
});
export const marketOutcomeSettlementSchema = z.object({
    result: marketOutcomeSettlementResultSchema,
    value: z.number().optional().nullable(),
});
export const hockeyGoaltendingStatsSchema = z.object({
    shotsAgainst: z.number(),
    goalsAgainst: z.number(),
    saves: z.number(),
});
export const hockeyTotalStatsSchema = z.object({
    goals: z.number(),
    assists: z.number(),
    hits: z.number(),
    penalties: z.number(),
    penaltyMinutes: z.number(),
    points: z.number(),
    shots: z.number(),
    shotAttempts: z.number(),
    blockedAttempts: z.number(),
    blockedShots: z.number(),
    missedShots: z.number(),
    faceoffs: z.number(),
    faceoffsWon: z.number(),
    faceoffsLost: z.number(),
    giveaways: z.number(),
    takeaways: z.number(),
    plusMinus: z.number().optional().nullable(),
});
export const hockeyPowerPlayStatsSchema = z.object({
    shots: z.number(),
    goals: z.number(),
    assists: z.number(),
});
export const hockeyPlayerTimeOnIceStatsSchema = z.object({
    shifts: z.number().optional().nullable(),
    powerplay: z.number(),
    shorthanded: z.number(),
    avg: z.number(),
    evenstrength: z.number(),
    total: z.number(),
    overtime: z.number().optional().nullable(),
});
export const hockeyStatsSchema = z.object({
    total: hockeyTotalStatsSchema,
    powerplay: hockeyPowerPlayStatsSchema.optional().nullable(),
});
export const hockeyTeamStatsSchema = z.object({
    total: hockeyTotalStatsSchema,
    powerplay: hockeyPowerPlayStatsSchema.optional().nullable(),
    stat_type: z.literal("HockeyTeamStats").optional(),
    goaltending: hockeyGoaltendingStatsSchema,
});
export const propositionNameSchema = z.record(z.string(), z.unknown()).and(z.object({
    friendly: z.string(),
    alias: z.string(),
}));
export const filterSchema = z.record(z.string(), z.unknown()).and(z.object({
    id: z.string(),
    label: z.string(),
}));
export const leagueCompetitionConfigDtoSchema = z
    .record(z.string(), z.unknown())
    .and(z.object({
    id: leagueCompetitionSchema,
    name: z.string(),
    active: z.boolean(),
    seasonInProgress: z.boolean().optional().nullable(),
    upcomingDates: z.array(z.string()).optional().nullable(),
    curSeason: z.string().optional().nullable(),
    splits: z.array(filterSchema),
}));
export const matchupTacticStatSchema = z.object({
    tactic: matchupTacticSchema,
    stat: z.string(),
    name: z.string(),
    invert: z.boolean().optional().nullable(),
});
export const rosterSourceMappingSchema = z.record(z.string(), z.unknown()).and(z.object({
    sourceId: z.string(),
    altSourceId: z.string().optional().nullable(),
}));
export const rosterPlayerSchema = z.record(z.string(), z.unknown()).and(z.object({
    playerId: z.string(),
    status: z.string(),
    fullName: z.string(),
    altFullNames: z.array(z.string()).optional().nullable(),
    firstName: z.string(),
    lastName: z.string(),
    preferredName: z.string().optional().nullable(),
    suffix: z.string().optional().nullable(),
    position: z.string().optional().nullable(),
    primaryPosition: z.string().optional().nullable(),
    jerseyNumber: z.string().optional().nullable(),
    sourceMap: z.record(z.string(), rosterSourceMappingSchema),
    extraProps: z.record(z.string(), z.unknown()).optional().nullable(),
}));
export const playerMatchSchema = z.record(z.string(), z.unknown()).and(z.object({
    playerId: z.string(),
    match: z.string(),
}));
export const injurySchema = z.record(z.string(), z.unknown()).and(z.object({
    status: injuryStatusSchema,
    hasNews: z.boolean(),
    injury: z.string().optional().nullable(),
    shortText: z.string().optional().nullable(),
    headline: z.string().optional().nullable(),
    analysis: z.string().optional().nullable(),
    startDate: z.string().optional().nullable(),
    returnDate: z.string().optional().nullable(),
    lastUpdated: z.string().optional().nullable(),
}));
export const eventDtoSchema = z.object({
    leagueId: z.string(),
    competitionId: z.string().optional().nullable(),
    eventId: z.string(),
    scheduledTime: z.string(),
    live: z.boolean(),
    status: z.string(),
    venue: z.string().optional().nullable(),
    network: z.string().optional().nullable(),
    season: z.number(),
    code: z.string(),
    home: versusTeamSchema,
    away: versusTeamSchema,
    neutralSite: z.boolean().optional().nullable(),
    dayOfWeek: z.number().optional().nullable(),
    timezone: z.string().optional().nullable(),
});
export const baseballVenueStatsSchema = z.object({
    venue_stats_type: z.literal("BaseballVenueStats").optional(),
    parkFactors: z.array(baseballParkFactorSplitSchema),
});
export const eventVenueSchema = z.object({
    id: z.string(),
    name: z.string(),
    city: z.string(),
    country: z.string(),
    region: z.string().optional().nullable(),
    capacity: z.number().optional().nullable(),
    timezone: z.string().optional().nullable(),
    surface: z.string().optional().nullable(),
    latitude: z.string().optional().nullable(),
    longitude: z.string().optional().nullable(),
    stadiumType: z.string().optional().nullable(),
    roofType: z.string().optional().nullable(),
    fieldOrientation: z.string().optional().nullable(),
    fieldOrientationDeg: z.number().optional().nullable(),
    fieldOrientationNorthDeg: z.number().optional().nullable(),
    outfieldDistances: baseballBallparkDistancesSchema.optional().nullable(),
    sourceMap: z.record(z.string(), z.string()),
});
export const marketOutcomeDtoSchema = z.object({
    outcomeId: z.string(),
    position: positionSchema,
    line: z.number(),
    odds: z.array(bookOddsDtoSchema),
    teamId: z.string().optional().nullable(),
    player: marketPlayerMetadataSchema.optional().nullable(),
    label: z.string(),
    lineLabel: z.string().optional().nullable(),
    books: z.array(dataProviderSchema),
    primary: z.boolean(),
    bookPrimary: z.boolean(),
    stats: marketOutcomeSummaryStatsSchema.optional().nullable(),
    outcomeProps: z.record(z.string(), z.unknown()).optional().nullable(),
    settlement: marketOutcomeSettlementSchema.optional().nullable(),
});
export const bookOddsSchema = z.object({
    american: z.string(),
    decimal: z.number(),
    fraction: oddsFractionSchema,
    state: marketStateSchema,
    book: bookIdentifierSchema,
    maxBet: z.number().optional().nullable(),
});
export const deVigMethodCalculatedEVSchema = z.object({
    noVigOdds: oddsSchema,
    ev: z.number(),
    kelly: z.number(),
});
export const middleBetDtoSchema = z.object({
    outcomeId: z.string(),
    summaryStat: marketOutcomeSummaryStatsSchema.optional().nullable(),
    outcomeLabel: z.string(),
    lineLabel: z.string().optional().nullable(),
    teamId: z.string().optional().nullable(),
    position: positionSchema,
    odds: oddsSchema,
    stake: z.string(),
    linkSets: z.record(z.string(), linkSetSchema).optional().nullable(),
    books: z.record(z.string(), bookOddsSchema),
});
export const middleBetPayoutDtoSchema = z.object({
    payout: z.number(),
    scenario: z.string(),
    outcome_results: z.record(z.string(), betResultSchema),
    probability: z.number().optional().nullable(),
});
export const outcomeMetadataSchema = z.object({
    outcomeLabel: z.string(),
    lineLabel: z.string().optional().nullable(),
    teamId: z.string().optional().nullable(),
    position: position1Schema.optional(),
});
export const outcomeOddsTimelineDtoSchema = z.object({
    timestamp: z.string(),
    bookId: dataProviderSchema,
    oddsDecimal: z.number(),
    oddsAmerican: z.string(),
    oddsFraction: oddsFractionSchema,
});
export const statsGameSchema = z.object({
    competitionId: leagueCompetitionSchema.optional().nullable(),
    eventId: z.string(),
    scheduledTime: z.string(),
    home: statsTeamSchema,
    away: statsTeamSchema,
    neutralSite: z.boolean().optional().nullable(),
    dayOfWeek: z.number().optional().nullable(),
    timezone: z.string().optional().nullable(),
});
export const statsPlayerSchema = z.object({
    playerId: z.string(),
    firstName: z.string(),
    lastName: z.string(),
    position: z.string().optional().nullable(),
    jerseyNumber: z.string().optional().nullable(),
    suffix: z.string().optional().nullable(),
});
export const footballPlayerStatsSchema = z.object({
    receiving: footballReceivingStatsSchema.optional().nullable(),
    passing: footballPassingStatsSchema.optional().nullable(),
    rushing: footballRushingStatsSchema.optional().nullable(),
    touchdown: footballTouchdownStatsSchema.optional().nullable(),
    fieldGoal: footballFieldGoalStatsSchema.optional().nullable(),
    defense: footballDefensiveStatsSchema.optional().nullable(),
    extraPoint: footballExtraPointStatsSchema.optional().nullable(),
    fumbles: footballFumbleStatsSchema.optional().nullable(),
    conversions: footballConversionStatsSchema.optional().nullable(),
    punts: footballPuntStatsSchema.optional().nullable(),
    teamTotals: footballTeamTotalsSchema.optional().nullable(),
    oppTeamTotals: footballTeamTotalsSchema.optional().nullable(),
    stat_type: z.literal("FootballPlayerStats").optional(),
    fantasyScoreUD: z.number().optional().nullable(),
    fantasyScoreSLP: z.number().optional().nullable(),
    fantasyScorePP: z.number().optional().nullable(),
    firstTd: z.boolean().optional().nullable(),
    lastTd: z.boolean().optional().nullable(),
    firstTeamTd: z.boolean().optional().nullable(),
    firstReception: z.boolean().optional().nullable(),
    firstTeamReception: z.boolean().optional().nullable(),
    firstPassCompletion: z.boolean().optional().nullable(),
    firstRush: z.boolean().optional().nullable(),
    mostPassYds: z.boolean().optional().nullable(),
    mostRecvYds: z.boolean().optional().nullable(),
    mostRushYds: z.boolean().optional().nullable(),
    mostRushRecvYds: z.boolean().optional().nullable(),
    mostTacklesAssists: z.boolean().optional().nullable(),
    mostSacks: z.boolean().optional().nullable(),
});
export const hockeyPlayerStatsSchema = z.object({
    total: hockeyTotalStatsSchema,
    powerplay: hockeyPowerPlayStatsSchema.optional().nullable(),
    stat_type: z.literal("HockeyPlayerStats").optional(),
    fantasyScoreUD: z.number().optional().nullable(),
    fantasyScoreSLP: z.number().optional().nullable(),
    fantasyScorePP: z.number().optional().nullable(),
    goaltending: hockeyGoaltendingStatsSchema.optional().nullable(),
    timeOnIce: hockeyPlayerTimeOnIceStatsSchema.optional().nullable(),
});
export const soccerPlayerStatsSchema = z.object({
    xG: z.number(),
    npxG: z.number(),
    xGHeader: z.number(),
    xGOpenPlay: z.number(),
    xGSetPlay: z.number(),
    xGFreeKick: z.number(),
    xGConceded: z.number(),
    npxGConceded: z.number(),
    xGOT: z.number(),
    npxGOT: z.number(),
    xGOTConceded: z.number(),
    npxGOTConceded: z.number(),
    xA: z.number(),
    xASetPlay: z.number(),
    xAOpenPlay: z.number(),
    assists: z.number(),
    goals: z.number(),
    shotsOnGoal: z.number(),
    shotsBlocked: z.number(),
    shotsOffTarget: z.number(),
    shotAttempts: z.number(),
    shotAttemptsSetPiece: z.number(),
    shotsHeader: z.number(),
    shotsOnGoalHeader: z.number(),
    goalsHeader: z.number(),
    shotsObox: z.number(),
    shotsOnGoalObox: z.number(),
    goalsObox: z.number(),
    shotsIbox: z.number(),
    shotsOnGoalIbox: z.number(),
    goalsIbox: z.number(),
    shotsFastbreak: z.number(),
    bigChanceCreated: z.number(),
    bigChanceMissed: z.number(),
    bigChanceScored: z.number(),
    penaltyAttempts: z.number(),
    penaltyGoals: z.number(),
    totalPasses: z.number(),
    accuratePasses: z.number(),
    keyPasses: z.number(),
    keyPassesShotOnGoal: z.number(),
    forwardPasses: z.number(),
    totalPassesFinalThird: z.number(),
    accuratePassesFinalThird: z.number(),
    totalPassesOppHalf: z.number(),
    accuratePassesOppHalf: z.number(),
    totalPassesOwnHalf: z.number(),
    accuratePassesOwnHalf: z.number(),
    finalThirdEntries: z.number(),
    boxEntries: z.number(),
    totalThroughBalls: z.number(),
    accurateThroughBalls: z.number(),
    totalLongBalls: z.number(),
    accurateLongBalls: z.number(),
    totalCrosses: z.number(),
    accurateCrosses: z.number(),
    totalCrossesNoCorner: z.number(),
    accurateCrossesNoCorner: z.number(),
    cornersTaken: z.number(),
    crossesFreeKick: z.number(),
    touches: z.number(),
    touchesInOppBox: z.number(),
    totalDribbleAtt: z.number(),
    wonDribbleAtt: z.number(),
    overruns: z.number(),
    timesTackled: z.number(),
    aerialWon: z.number(),
    aerialLost: z.number(),
    duelWon: z.number(),
    duelLost: z.number(),
    totalClearances: z.number(),
    headClearances: z.number(),
    totalTackles: z.number(),
    wonTackles: z.number(),
    ballRecoveries: z.number(),
    blockedCrosses: z.number(),
    blockedPasses: z.number(),
    blockedShots: z.number(),
    interceptions: z.number(),
    interceptionsInBox: z.number(),
    dangerousPlays: z.number(),
    offsides: z.number().optional(),
    stat_type: z.literal("SoccerPlayerStats").optional(),
    starter: z.boolean(),
    subOff: z.number(),
    subOn: z.number(),
    minutes: z.number(),
    fouls: z.number(),
    foulsDrawn: z.number(),
    yellowCard: z.number(),
    secondYellow: z.number(),
    redCard: z.number(),
    redCardRescinded: z.number(),
    saves: z.number().optional().nullable(),
    shotsConcededObox: z.number().optional().nullable(),
    shotsConcededIbox: z.number().optional().nullable(),
    goalsConceded: z.number().optional().nullable(),
    goalsConcededObox: z.number().optional().nullable(),
    goalsConcededIbox: z.number().optional().nullable(),
    cleanSheet: z.boolean().optional().nullable(),
    penaltiesFaced: z.number().optional().nullable(),
    penaltySaves: z.number().optional().nullable(),
    divingSaves: z.number().optional().nullable(),
    caughtSaves: z.number().optional().nullable(),
    firstBooked: z.boolean().optional().nullable(),
    firstGoal: z.boolean().optional().nullable(),
    firstTeamGoal: z.boolean().optional().nullable(),
    lastGoal: z.boolean().optional().nullable(),
    lastTeamGoal: z.boolean().optional().nullable(),
    firstAssist: z.boolean().optional().nullable(),
});
export const playerGameStatsSourceMappingSchema = z.object({
    playerId: z.string(),
    teamId: z.string(),
    homeTeamId: z.string(),
    awayTeamId: z.string(),
    homeAwaySwap: z.boolean().optional().nullable(),
});
export const soccerPeriodPlayerStatsSchema = z.object({
    stat_type: z.literal("SoccerPeriodPlayerStats").optional(),
    assists: z.number(),
    goals: z.number(),
    shotsOnGoal: z.number(),
    shotAttempts: z.number(),
});
export const playerStatsPeriodSchema = z.object({
    number: z.number(),
    sequence: z.number(),
    type: z.string(),
    stats: z.union([
        baseballPeriodPlayerStatsSchema,
        footballPeriodPlayerStatsSchema,
        basketballPeriodStatsSchema,
        soccerPeriodPlayerStatsSchema,
    ]),
});
export const positiveEVBetDtoSchema = z.object({
    outcomeId: z.string(),
    summaryStat: marketOutcomeSummaryStatsSchema.optional().nullable(),
    books: z.record(z.string(), bookOddsSchema),
    vig: z.number(),
    width: z.number(),
    deVigOdds: oddsSchema,
    calculatedEV: z.record(z.string(), deVigMethodCalculatedEVSchema.nullable()),
    devigOddsStatistics: deVigOddsStatisticsSchema.optional().nullable(),
    leagueId: leagueSchema,
    competitionId: leagueCompetitionSchema.optional().nullable(),
    sport: sportSchema,
    eventId: z.string(),
    event: marketEventMetadataSchema,
    marketId: z.string(),
    proposition: propositionSchema,
    marketType: marketTypeSchema,
    propType: propTypeSchema,
    periods: z.array(z.number()).optional().nullable(),
    marketLabel: z.string(),
    outcomeLabel: z.string(),
    lineLabel: z.string().optional().nullable(),
    teamId: z.string().optional().nullable(),
    position: positionSchema,
    odds: oddsSchema,
    allOdds: z
        .record(z.string(), z.record(z.string(), oddsSchema))
        .optional()
        .nullable(),
    balancingOutcomesMetadata: z
        .record(z.string(), outcomeMetadataSchema)
        .optional()
        .nullable(),
    linkSets: z.record(z.string(), linkSetSchema).optional().nullable(),
});
export const bookAmericanDefaultOddsSchema = z
    .record(z.string(), z.unknown())
    .and(z.object({
    odds: z.string(),
    decimal: z.number(),
    fraction: oddsFractionSchema,
    identifier: selectionIdsSchema,
}));
export const propOutcomeSchema = z.object({
    leagueId: leagueSchema,
    competitionId: leagueCompetitionSchema.optional().nullable(),
    eventId: z.string(),
    playerId: z.string(),
    teamId: z.string().optional().nullable(),
    oppTeamId: z.string().optional().nullable(),
    marketId: z.string(),
    outcomeId: z.string(),
    marketLabel: z.string(),
    periodLabel: z.string().optional().nullable(),
    includeOvertime: z.boolean(),
    proposition: propositionSchema,
    line: z.number(),
    position: positionSchema,
    outcomeLabel: z.string(),
    bestOdds: z.string(),
    primary: z.boolean(),
    active: z.boolean(),
    books: z.array(dataProviderSchema),
    bookOdds: z
        .record(z.string(), bookAmericanDefaultOddsSchema)
        .optional()
        .nullable(),
    ev: z.number().optional().nullable(),
});
export const propOutcomeStatsSchema = z.object({
    l20: z.number().optional().nullable(),
    l10: z.number().optional().nullable(),
    l5: z.number().optional().nullable(),
    h2h: z.number().optional().nullable(),
    curSeason: z.number().optional().nullable(),
    prevSeason: z.number().optional().nullable(),
});
export const soccerBaseTeamStatsSchema = z.object({
    xG: z.number(),
    npxG: z.number(),
    xGHeader: z.number(),
    xGOpenPlay: z.number(),
    xGSetPlay: z.number(),
    xGFreeKick: z.number(),
    xGConceded: z.number(),
    npxGConceded: z.number(),
    xGOT: z.number(),
    npxGOT: z.number(),
    xGOTConceded: z.number(),
    npxGOTConceded: z.number(),
    xA: z.number(),
    xASetPlay: z.number(),
    xAOpenPlay: z.number(),
    assists: z.number(),
    goals: z.number(),
    shotsOnGoal: z.number(),
    shotsBlocked: z.number(),
    shotsOffTarget: z.number(),
    shotAttempts: z.number(),
    shotAttemptsSetPiece: z.number(),
    shotsHeader: z.number(),
    shotsOnGoalHeader: z.number(),
    goalsHeader: z.number(),
    shotsObox: z.number(),
    shotsOnGoalObox: z.number(),
    goalsObox: z.number(),
    shotsIbox: z.number(),
    shotsOnGoalIbox: z.number(),
    goalsIbox: z.number(),
    shotsFastbreak: z.number(),
    bigChanceCreated: z.number(),
    bigChanceMissed: z.number(),
    bigChanceScored: z.number(),
    penaltyAttempts: z.number(),
    penaltyGoals: z.number(),
    totalPasses: z.number(),
    accuratePasses: z.number(),
    keyPasses: z.number(),
    keyPassesShotOnGoal: z.number(),
    forwardPasses: z.number(),
    totalPassesFinalThird: z.number(),
    accuratePassesFinalThird: z.number(),
    totalPassesOppHalf: z.number(),
    accuratePassesOppHalf: z.number(),
    totalPassesOwnHalf: z.number(),
    accuratePassesOwnHalf: z.number(),
    finalThirdEntries: z.number(),
    boxEntries: z.number(),
    totalThroughBalls: z.number(),
    accurateThroughBalls: z.number(),
    totalLongBalls: z.number(),
    accurateLongBalls: z.number(),
    totalCrosses: z.number(),
    accurateCrosses: z.number(),
    totalCrossesNoCorner: z.number(),
    accurateCrossesNoCorner: z.number(),
    cornersTaken: z.number(),
    crossesFreeKick: z.number(),
    touches: z.number(),
    touchesInOppBox: z.number(),
    totalDribbleAtt: z.number(),
    wonDribbleAtt: z.number(),
    overruns: z.number(),
    timesTackled: z.number(),
    aerialWon: z.number(),
    aerialLost: z.number(),
    duelWon: z.number(),
    duelLost: z.number(),
    totalClearances: z.number(),
    headClearances: z.number(),
    totalTackles: z.number(),
    wonTackles: z.number(),
    ballRecoveries: z.number(),
    blockedCrosses: z.number(),
    blockedPasses: z.number(),
    blockedShots: z.number(),
    interceptions: z.number(),
    interceptionsInBox: z.number(),
    dangerousPlays: z.number(),
    offsides: z.number().optional(),
    fouls: z.number(),
    yellowCards: z.number(),
    redCards: z.number(),
    secondYellow: z.number(),
    goalKicks: z.number(),
    saves: z.number(),
    goalsConceded: z.number(),
    cleanSheet: z.number(),
    wonCorners: z.number(),
    lostCorners: z.number(),
    possessionPct: z.number(),
});
export const soccerPeriodTeamStatsSchema = z.object({
    xG: z.number(),
    npxG: z.number(),
    xGHeader: z.number(),
    xGOpenPlay: z.number(),
    xGSetPlay: z.number(),
    xGFreeKick: z.number(),
    xGConceded: z.number(),
    npxGConceded: z.number(),
    xGOT: z.number(),
    npxGOT: z.number(),
    xGOTConceded: z.number(),
    npxGOTConceded: z.number(),
    xA: z.number(),
    xASetPlay: z.number(),
    xAOpenPlay: z.number(),
    assists: z.number(),
    goals: z.number(),
    shotsOnGoal: z.number(),
    shotsBlocked: z.number(),
    shotsOffTarget: z.number(),
    shotAttempts: z.number(),
    shotAttemptsSetPiece: z.number(),
    shotsHeader: z.number(),
    shotsOnGoalHeader: z.number(),
    goalsHeader: z.number(),
    shotsObox: z.number(),
    shotsOnGoalObox: z.number(),
    goalsObox: z.number(),
    shotsIbox: z.number(),
    shotsOnGoalIbox: z.number(),
    goalsIbox: z.number(),
    shotsFastbreak: z.number(),
    bigChanceCreated: z.number(),
    bigChanceMissed: z.number(),
    bigChanceScored: z.number(),
    penaltyAttempts: z.number(),
    penaltyGoals: z.number(),
    totalPasses: z.number(),
    accuratePasses: z.number(),
    keyPasses: z.number(),
    keyPassesShotOnGoal: z.number(),
    forwardPasses: z.number(),
    totalPassesFinalThird: z.number(),
    accuratePassesFinalThird: z.number(),
    totalPassesOppHalf: z.number(),
    accuratePassesOppHalf: z.number(),
    totalPassesOwnHalf: z.number(),
    accuratePassesOwnHalf: z.number(),
    finalThirdEntries: z.number(),
    boxEntries: z.number(),
    totalThroughBalls: z.number(),
    accurateThroughBalls: z.number(),
    totalLongBalls: z.number(),
    accurateLongBalls: z.number(),
    totalCrosses: z.number(),
    accurateCrosses: z.number(),
    totalCrossesNoCorner: z.number(),
    accurateCrossesNoCorner: z.number(),
    cornersTaken: z.number(),
    crossesFreeKick: z.number(),
    touches: z.number(),
    touchesInOppBox: z.number(),
    totalDribbleAtt: z.number(),
    wonDribbleAtt: z.number(),
    overruns: z.number(),
    timesTackled: z.number(),
    aerialWon: z.number(),
    aerialLost: z.number(),
    duelWon: z.number(),
    duelLost: z.number(),
    totalClearances: z.number(),
    headClearances: z.number(),
    totalTackles: z.number(),
    wonTackles: z.number(),
    ballRecoveries: z.number(),
    blockedCrosses: z.number(),
    blockedPasses: z.number(),
    blockedShots: z.number(),
    interceptions: z.number(),
    interceptionsInBox: z.number(),
    dangerousPlays: z.number(),
    offsides: z.number().optional(),
    fouls: z.number(),
    yellowCards: z.number(),
    redCards: z.number(),
    secondYellow: z.number(),
    goalKicks: z.number(),
    saves: z.number(),
    goalsConceded: z.number(),
    cleanSheet: z.number(),
    wonCorners: z.number(),
    lostCorners: z.number(),
    possessionPct: z.number(),
    stat_type: z.literal("SoccerPeriodTeamStats").optional(),
});
export const soccerTeamStatsSchema = z.object({
    xG: z.number(),
    npxG: z.number(),
    xGHeader: z.number(),
    xGOpenPlay: z.number(),
    xGSetPlay: z.number(),
    xGFreeKick: z.number(),
    xGConceded: z.number(),
    npxGConceded: z.number(),
    xGOT: z.number(),
    npxGOT: z.number(),
    xGOTConceded: z.number(),
    npxGOTConceded: z.number(),
    xA: z.number(),
    xASetPlay: z.number(),
    xAOpenPlay: z.number(),
    assists: z.number(),
    goals: z.number(),
    shotsOnGoal: z.number(),
    shotsBlocked: z.number(),
    shotsOffTarget: z.number(),
    shotAttempts: z.number(),
    shotAttemptsSetPiece: z.number(),
    shotsHeader: z.number(),
    shotsOnGoalHeader: z.number(),
    goalsHeader: z.number(),
    shotsObox: z.number(),
    shotsOnGoalObox: z.number(),
    goalsObox: z.number(),
    shotsIbox: z.number(),
    shotsOnGoalIbox: z.number(),
    goalsIbox: z.number(),
    shotsFastbreak: z.number(),
    bigChanceCreated: z.number(),
    bigChanceMissed: z.number(),
    bigChanceScored: z.number(),
    penaltyAttempts: z.number(),
    penaltyGoals: z.number(),
    totalPasses: z.number(),
    accuratePasses: z.number(),
    keyPasses: z.number(),
    keyPassesShotOnGoal: z.number(),
    forwardPasses: z.number(),
    totalPassesFinalThird: z.number(),
    accuratePassesFinalThird: z.number(),
    totalPassesOppHalf: z.number(),
    accuratePassesOppHalf: z.number(),
    totalPassesOwnHalf: z.number(),
    accuratePassesOwnHalf: z.number(),
    finalThirdEntries: z.number(),
    boxEntries: z.number(),
    totalThroughBalls: z.number(),
    accurateThroughBalls: z.number(),
    totalLongBalls: z.number(),
    accurateLongBalls: z.number(),
    totalCrosses: z.number(),
    accurateCrosses: z.number(),
    totalCrossesNoCorner: z.number(),
    accurateCrossesNoCorner: z.number(),
    cornersTaken: z.number(),
    crossesFreeKick: z.number(),
    touches: z.number(),
    touchesInOppBox: z.number(),
    totalDribbleAtt: z.number(),
    wonDribbleAtt: z.number(),
    overruns: z.number(),
    timesTackled: z.number(),
    aerialWon: z.number(),
    aerialLost: z.number(),
    duelWon: z.number(),
    duelLost: z.number(),
    totalClearances: z.number(),
    headClearances: z.number(),
    totalTackles: z.number(),
    wonTackles: z.number(),
    ballRecoveries: z.number(),
    blockedCrosses: z.number(),
    blockedPasses: z.number(),
    blockedShots: z.number(),
    interceptions: z.number(),
    interceptionsInBox: z.number(),
    dangerousPlays: z.number(),
    offsides: z.number().optional(),
    fouls: z.number(),
    yellowCards: z.number(),
    redCards: z.number(),
    secondYellow: z.number(),
    goalKicks: z.number(),
    saves: z.number(),
    goalsConceded: z.number(),
    cleanSheet: z.number(),
    wonCorners: z.number(),
    lostCorners: z.number(),
    possessionPct: z.number(),
    stat_type: z.literal("SoccerTeamStats").optional(),
});
export const statValueSchema = z.object({
    formatted: z.string(),
    num: z.number().optional().nullable(),
    rank: z.number().optional().nullable(),
    rankAdj: z.number().optional().nullable(),
    rankPct: z.number().optional().nullable(),
    rankPctAdj: z.number().optional().nullable(),
    rankTotal: z.number().optional().nullable(),
});
export const statsMappingFailureSchema = z.object({
    runId: z.string(),
    msg: z.string(),
    mappingFailureType: statsMappingFailureTypeSchema,
    providerId: dataProviderSchema,
    mapFromProviderId: dataProviderSchema,
    mapToProviderId: dataProviderSchema,
    providerEntityId: z.string(),
    errorMsg: z.string().optional().nullable(),
    league: leagueSchema.optional().nullable(),
    competition: leagueCompetitionSchema.optional().nullable(),
    sport: sportSchema.optional().nullable(),
    eventId: z.string().optional().nullable(),
    eventName: z.string().optional().nullable(),
    teamId: z.string().optional().nullable(),
    teamName: z.string().optional().nullable(),
    playerId: z.string().optional().nullable(),
    playerName: z.string().optional().nullable(),
    providerEventId: z.string().optional().nullable(),
    providerTeamId: z.string().optional().nullable(),
    providerTeamName: z.string().optional().nullable(),
    providerPlayerId: z.string().optional().nullable(),
    providerPlayerName: z.string().optional().nullable(),
    rawProviderEntity: z.record(z.string(), z.unknown()).optional().nullable(),
});
export const statsPeriodSchema = z.object({
    number: z.number(),
    sequence: z.number(),
    type: z.string(),
});
export const teamGameStatsSourceMappingSchema = z.object({
    teamId: z.string(),
    eventId: z.string(),
    homeAwaySwap: z.boolean().optional().nullable(),
});
export const teamPeriodScoreAndStatsSchema = z.object({
    score: z.number().optional().nullable(),
    stats: z
        .union([
        baseballPeriodTeamStatsSchema,
        footballPeriodTeamStatsSchema,
        basketballPeriodStatsSchema,
        soccerPeriodTeamStatsSchema,
    ])
        .optional()
        .nullable(),
});
export const teamMetadataTeamSchema = z.record(z.string(), z.unknown()).and(z.object({
    teamId: z.string(),
    market: z.string(),
    name: z.string(),
    fullName: z.string(),
    alias: z.string(),
    backgroundHex: z.string(),
    altHex: z.array(z.string()),
    logo: z.string().optional().nullable(),
}));
export const teamRecordDetailsSchema = z.object({
    win: z.number(),
    loss: z.number(),
    tie: z.number().optional().nullable(),
});
export const teamRecordSplitSchema = z.record(z.string(), z.unknown()).and(z.object({
    win: z.number(),
    loss: z.number(),
    tie: z.number().optional().nullable(),
    split: z.string(),
    label: z.string(),
}));
export const scheduleStrengthSchema = z.record(z.string(), z.unknown()).and(z.object({
    value: z.number(),
    wins: z.number(),
    total: z.number(),
}));
export const teamStatsPeriodSchema = z.object({
    number: z.number(),
    sequence: z.number(),
    type: z.string(),
    home: teamPeriodScoreAndStatsSchema,
    away: teamPeriodScoreAndStatsSchema,
});
export const outcomeConsensusSchema = z.record(z.string(), z.unknown()).and(z.object({
    position: positionSchema,
    odds: z.string(),
    line: z.number().optional().nullable(),
}));
export const trendingPickBookAvailabilityDtoSchema = z.object({
    legs: z.number(),
    linkSet: linkSetSchema,
});
export const trendingPickUserInfoSchema = z.object({
    userId: z.string(),
    userPickCreated: z.string(),
    avatar: z.string(),
    name: z.string().optional().nullable(),
    twitter: z.string().optional().nullable(),
    discord: z.string().optional().nullable(),
    website: z.string().optional().nullable(),
    referralLink: z.string().optional().nullable(),
});
export const trendingPickSelectionMarketDtoSchema = z.object({
    marketId: z.string(),
    marketType: marketTypeSchema,
    proposition: propositionSchema,
    event: marketEventMetadataSchema,
    propType: propTypeSchema,
    periods: z.array(z.number()).optional().nullable(),
    teamId: z.string().optional().nullable(),
    sport: sportSchema,
    marketLabel: z.string(),
});
export const trendingPickSelectionBookOddsDtoSchema = z.object({
    american: z.string(),
    decimal: z.number(),
    fraction: oddsFractionSchema,
    state: marketStateSchema,
    book: bookIdentifierSchema,
    linkSet: linkSetSchema,
});
export const arbitrageBetDtoSchema = z.object({
    outcomeId: z.string(),
    summaryStat: marketOutcomeSummaryStatsSchema.optional().nullable(),
    outcomeLabel: z.string(),
    lineLabel: z.string().optional().nullable(),
    teamId: z.string().optional().nullable(),
    position: positionSchema,
    odds: oddsSchema,
    stake: z.string(),
    profit: z.string(),
    roundStake: z.string(),
    roundProfit: z.string(),
    linkSets: z.record(z.string(), linkSetSchema).optional().nullable(),
    books: z.record(z.string(), bookOddsSchema),
});
export const arbitrageOpportunityDtoSchema = z.object({
    id: z.string(),
    percent: z.number(),
    leagueId: leagueSchema,
    competitionId: leagueCompetitionSchema.optional().nullable(),
    sport: sportSchema,
    eventId: z.string(),
    event: marketEventMetadataSchema,
    marketId: z.string(),
    proposition: propositionSchema,
    marketType: marketTypeSchema,
    propType: propTypeSchema,
    periods: z.array(z.number()).optional().nullable(),
    marketLabel: z.string(),
    bets: z.array(arbitrageBetDtoSchema),
});
export const baseStatsSchema = z.object({
    teamId: z.string(),
    leagueId: leagueSchema,
    competitionId: leagueCompetitionSchema.optional().nullable(),
    season: statsSeasonSchema,
    game: statsGameSchema,
    source: dataProviderSchema,
    score: statsGameScoreSchema,
});
export const eventWeatherSchema = z.object({
    eventId: z.string(),
    scheduledTime: z.string(),
    scheduledTimeLocal: z.string(),
    hourlyForecast: z.array(eventWeatherHourlyForecastSchema),
});
export const historicMarketDtoSchema = z.object({
    marketId: z.string(),
    event: marketEventMetadataSchema,
    leagueId: leagueSchema,
    competitionId: leagueCompetitionSchema.optional().nullable(),
    sport: sportSchema,
    marketType: marketTypeSchema,
    propType: propTypeSchema,
    proposition: propositionSchema,
    periods: z.array(z.number()).optional().nullable(),
    periodLabel: z.string().optional().nullable(),
    includeOvertime: z.boolean(),
    teamId: z.string().optional().nullable(),
    player: marketPlayerMetadataSchema.optional().nullable(),
    outcomes: z.array(marketOutcomeDtoSchema),
    books: z.array(dataProviderSchema),
    label: z.string(),
    outcomeMap: z.array(z.array(z.string().nullable())),
});
export const leagueConfigDtoSchema = z.record(z.string(), z.unknown()).and(z.object({
    id: leagueSchema,
    sport: sportSchema,
    label: z.string(),
    active: z.boolean(),
    seasonInProgress: z.boolean().optional().nullable(),
    dateFilters: z.array(filterSchema).optional().nullable(),
    upcomingDates: z.array(z.string()).optional().nullable(),
    playerPropFilters: z.array(filterSchema),
    teamPropFilters: z.array(filterSchema),
    gamePropFilters: z.array(filterSchema),
    gamelineFilters: z.array(filterSchema),
    discludedSeasonCodes: z.array(z.string()),
    splits: z.array(filterSchema),
    features: featureTogglesSchema,
    propDesignations: z
        .record(z.string(), z.array(z.string()))
        .optional()
        .nullable(),
    propOrder: z.array(propositionSchema),
    positionOrder: z.array(z.string()),
    leagueConfigProperties: z
        .record(z.string(), z.unknown())
        .optional()
        .nullable(),
    competitions: z
        .array(leagueCompetitionConfigDtoSchema)
        .optional()
        .nullable(),
}));
export const propositionMatchupStatMappingSchema = z.object({
    primary: matchupTacticStatSchema,
    composite: z.array(matchupTacticStatSchema).optional().nullable(),
});
export const rosterTeamSchema = z.record(z.string(), z.unknown()).and(z.object({
    teamId: z.string(),
    market: z.string(),
    name: z.string(),
    fullName: z.string(),
    alias: z.string(),
    shortName: z.string().optional().nullable(),
    altNames: z.array(z.string()).optional().nullable(),
    altAliases: z.array(z.string()).optional().nullable(),
    conference: z.string().optional().nullable(),
    division: z.string().optional().nullable(),
    sourceMap: z.record(z.string(), rosterSourceMappingSchema),
}));
export const playerInjurySchema = z.record(z.string(), z.unknown()).and(z.object({
    playerId: z.string(),
    firstName: z.string(),
    lastName: z.string(),
    jerseyNumber: z.string().optional().nullable(),
    position: z.string().optional().nullable(),
    injury: injurySchema,
    priority: z.number().optional().nullable(),
}));
export const leagueScheduleDtoSchema = z.object({
    events: z.array(eventDtoSchema),
});
export const venueStatsSchema = z.object({
    stats: baseballVenueStatsSchema,
    venue: eventVenueSchema,
    homeTeamId: z.string().optional().nullable(),
});
export const positiveEVOutcomeDtoSchema = z.object({
    outcomeId: z.string(),
    summaryStat: marketOutcomeSummaryStatsSchema.optional().nullable(),
    books: z.record(z.string(), bookOddsSchema),
    vig: z.number(),
    width: z.number(),
    deVigOdds: oddsSchema,
    calculatedEV: z.record(z.string(), deVigMethodCalculatedEVSchema.nullable()),
    devigOddsStatistics: deVigOddsStatisticsSchema.optional().nullable(),
});
export const middleBetOpportunityDtoSchema = z.object({
    id: z.string(),
    percent: z.number(),
    ev: z.number().optional().nullable(),
    leagueId: leagueSchema,
    competitionId: leagueCompetitionSchema.optional().nullable(),
    sport: sportSchema,
    eventId: z.string(),
    event: marketEventMetadataSchema,
    marketId: z.string(),
    proposition: propositionSchema,
    marketType: marketTypeSchema,
    propType: propTypeSchema,
    periods: z.array(z.number()).optional().nullable(),
    marketLabel: z.string(),
    bets: z.array(middleBetDtoSchema),
    payouts: z.array(middleBetPayoutDtoSchema),
});
export const playerGameStatsSchema = z.object({
    teamId: z.string(),
    leagueId: leagueSchema,
    competitionId: leagueCompetitionSchema.optional().nullable(),
    season: statsSeasonSchema,
    game: statsGameSchema,
    source: dataProviderSchema,
    score: statsGameScoreSchema,
    player: statsPlayerSchema,
    periods: z.array(playerStatsPeriodSchema).optional().nullable(),
    stats: z.union([
        basketballStatsSchema,
        baseballPlayerStatsSchema,
        footballPlayerStatsSchema,
        hockeyPlayerStatsSchema,
        soccerPlayerStatsSchema,
    ]),
    sourceMap: z.record(z.string(), playerGameStatsSourceMappingSchema),
});
export const playerStatsGameLogSchema = z.record(z.string(), z.unknown()).and(z.object({
    teamId: z.string(),
    competitionId: leagueCompetitionSchema.optional().nullable(),
    season: statsSeasonSchema,
    game: statsGameSchema,
    score: statsGameScoreSchema,
    daysOfRest: z.number().optional().nullable(),
    daysOfRestType: daysOfRestTypeSchema.optional().nullable(),
    player: statsPlayerSchema,
    periods: z.array(playerStatsPeriodSchema).optional().nullable(),
    stats: z.union([
        basketballStatsSchema,
        baseballPlayerStatsSchema,
        footballPlayerStatsSchema,
        hockeyPlayerStatsSchema,
        soccerPlayerStatsSchema,
    ]),
}));
export const propOutcomeDtoSchema = z.object({
    outcome: propOutcomeSchema,
    stats: propOutcomeStatsSchema.optional().nullable(),
    groupId: marketGroupSchema,
    orf: oppRankingFavorabilitySchema.optional().nullable(),
    orfScore: z.number().optional().nullable(),
});
export const teamGameStatsSchema = z.object({
    teamId: z.string(),
    leagueId: leagueSchema,
    competitionId: leagueCompetitionSchema.optional().nullable(),
    season: statsSeasonSchema,
    game: statsGameSchema,
    source: dataProviderSchema,
    score: statsGameScoreSchema,
    periods: z.array(teamStatsPeriodSchema).optional().nullable(),
    home: z.union([
        basketballStatsSchema,
        baseballTeamStatsSchema,
        footballTeamStatsSchema,
        hockeyTeamStatsSchema,
        soccerTeamStatsSchema,
    ]),
    away: z.union([
        basketballStatsSchema,
        baseballTeamStatsSchema,
        footballTeamStatsSchema,
        hockeyTeamStatsSchema,
        soccerTeamStatsSchema,
    ]),
    sourceMap: z.record(z.string(), teamGameStatsSourceMappingSchema),
});
export const teamMetadataLeagueSchema = z.record(z.string(), z.unknown()).and(z.object({
    leagueId: z.string(),
    name: z.string(),
    teams: z.record(z.string(), teamMetadataTeamSchema),
    headshots: z.record(z.string(), z.string()),
}));
export const teamRecordOverallSchema = z.record(z.string(), z.unknown()).and(z.object({
    win: z.number(),
    loss: z.number(),
    tie: z.number().optional().nullable(),
    streakType: z.string().optional().nullable(),
    streakLength: z.number().optional().nullable(),
    sos: scheduleStrengthSchema.optional().nullable(),
    sov: scheduleStrengthSchema.optional().nullable(),
}));
export const marketConsensusSchema = z.record(z.string(), z.unknown()).and(z.object({
    marketId: z.string(),
    proposition: propositionSchema,
    outcomes: z.array(outcomeConsensusSchema).optional().nullable(),
}));
export const trendingPickSelectionOutcomeDtoSchema = z.object({
    outcomeId: z.string(),
    outcomeLabel: z.string(),
    position: positionSchema,
    line: z.number().optional().nullable(),
    lineLabel: z.string().optional().nullable(),
    bookOdds: z.array(trendingPickSelectionBookOddsDtoSchema),
    stats: marketOutcomeSummaryStatsSchema.optional().nullable(),
    publicMoney: z.array(bettingPercentageSchema).optional().nullable(),
});
export const leagueConfigsDtoSchema = z.object({
    leagues: z.array(leagueConfigDtoSchema),
    iosTemplates: z.record(z.string(), deeplinkTemplateDtoSchema),
    deeplinkTemplates: z.record(z.string(), deeplinkTemplateDtoSchema),
    linkTemplates: z.record(z.string(), deeplinkTemplateDtoSchema),
    propositionNames: z.record(z.string(), propositionNameSchema).optional(),
    positionNames: z.record(z.string(), z.string()).optional(),
    supportedAreas: z.array(z.string()),
    supportedDFSAreas: z.array(z.string()),
    supportedOtherAreas: z.array(z.string()),
    sportsbooks: z.array(dataProviderSchema),
    dfsPlatforms: z.array(dataProviderSchema),
    otherBooks: z.array(dataProviderSchema),
    devigBooks: z.array(dataProviderSchema),
    mappedMaxBetBooks: z.array(dataProviderSchema),
    bookOrder: z.array(dataProviderSchema),
    propToOppStats: z.record(z.string(), propositionMatchupStatMappingSchema.nullable()),
    propToOppStatsLeagueOverrides: z.record(z.string(), z.record(z.string(), propositionMatchupStatMappingSchema.nullable())),
    defaultFeature: featureSetSchema,
    defaultProFeature: featureSetSchema,
    insightSplits: z.array(filterSchema).optional(),
    injuryStatusSeverity: z.record(z.string(), injurySeveritySchema),
    injuryStatusAbbreviations: z.record(z.string(), z.string()),
    injurySeverityColor: z.record(z.string(), z.string()),
});
export const teamRosterSchema = z.record(z.string(), z.unknown()).and(z.object({
    leagueId: leagueSchema,
    competitionIds: z.array(leagueCompetitionSchema).optional().nullable(),
    team: rosterTeamSchema,
    source: z.string(),
    players: z.array(rosterPlayerSchema),
}));
export const injuryImpactsSchema = z.record(z.string(), z.unknown()).and(z.object({
    playerInjury: playerInjurySchema,
    impactedPlayers: z.array(playerMatchSchema),
}));
export const leagueVenueStatsSeasonSchema = z.object({
    statsYear: z.string(),
    label: z.string(),
    venues: z.array(venueStatsSchema),
    defaultForRankings: z.boolean().optional().nullable(),
});
export const liveMarketDtoSchema = z.object({
    marketId: z.string(),
    eventId: z.string(),
    leagueId: leagueSchema,
    competitionId: leagueCompetitionSchema.optional().nullable(),
    sport: sportSchema,
    marketType: marketTypeSchema,
    propType: propTypeSchema,
    proposition: propositionSchema,
    periods: z.array(z.number()).optional().nullable(),
    periodLabel: z.string().optional().nullable(),
    includeOvertime: z.boolean(),
    teamId: z.string().optional().nullable(),
    player: marketPlayerMetadataSchema.optional().nullable(),
    outcomes: z.array(marketOutcomeDtoSchema),
    referenceOnlyOutcomes: z.array(marketOutcomeDtoSchema).optional().nullable(),
    isActive: z.boolean(),
    books: z.array(dataProviderSchema),
    label: z.string(),
    outcomeMap: z.array(z.array(z.string().nullable())),
    referenceOutcomeMap: z.array(z.array(z.string())),
    publicMoney: z.array(bettingPercentageSchema),
    marketGroupId: z.string(),
    marketGroupSortOrder: z.number(),
    evOutcomes: z.array(positiveEVOutcomeDtoSchema).optional().nullable(),
    referenceOutcomes: z
        .record(z.string(), z.array(bookOddsSchema))
        .optional()
        .nullable(),
});
export const playerStatsGameLogsSchema = z.object({
    playerId: z.string(),
    leagueId: leagueSchema,
    gamelogs: z.array(playerStatsGameLogSchema),
});
export const teamMetadataMapSchema = z.object({
    leagues: z.record(z.string(), teamMetadataLeagueSchema),
});
export const teamRecordsSchema = z.object({
    overall: teamRecordOverallSchema,
    splits: z.array(teamRecordSplitSchema),
});
export const teamStatsGameLogSchema = z.record(z.string(), z.unknown()).and(z.object({
    teamId: z.string(),
    competitionId: leagueCompetitionSchema.optional().nullable(),
    season: statsSeasonSchema,
    game: statsGameSchema,
    score: statsGameScoreSchema,
    daysOfRest: z.number().optional().nullable(),
    daysOfRestType: daysOfRestTypeSchema.optional().nullable(),
    periods: z.array(teamStatsPeriodSchema).optional().nullable(),
    home: z.union([
        basketballStatsSchema,
        baseballTeamStatsSchema,
        footballTeamStatsSchema,
        hockeyTeamStatsSchema,
        soccerTeamStatsSchema,
    ]),
    away: z.union([
        basketballStatsSchema,
        baseballTeamStatsSchema,
        footballTeamStatsSchema,
        hockeyTeamStatsSchema,
        soccerTeamStatsSchema,
    ]),
    odds: z.array(marketConsensusSchema).optional().nullable(),
}));
export const trendingPickSelectionDtoSchema = z.object({
    leagueId: leagueSchema,
    competitionId: leagueCompetitionSchema.optional().nullable(),
    market: trendingPickSelectionMarketDtoSchema,
    outcome: trendingPickSelectionOutcomeDtoSchema,
    balancedOutcomes: z
        .array(trendingPickSelectionOutcomeDtoSchema)
        .optional()
        .nullable(),
});
export const leagueEntitiesSchema = z.object({
    leagueId: leagueSchema,
    teams: z.array(teamRosterSchema),
});
export const leagueInjuryImpactsSchema = z.object({
    league: leagueSchema,
    injuryImpacts: z.array(injuryImpactsSchema),
});
export const leagueVenueStatsSchema = z.object({
    leagueId: leagueSchema,
    seasons: z.array(leagueVenueStatsSeasonSchema),
});
export const teamStatsGameLogsSchema = z.object({
    teamId: z.string(),
    leagueId: leagueSchema,
    gamelogs: z.array(teamStatsGameLogSchema),
});
export const trendingPickDtoSchema = z.object({
    pickId: z.string(),
    pickSource: z.string(),
    legs: z.number(),
    totalBets: z.number().optional().nullable(),
    odds: z.string().optional().nullable(),
    decimalOdds: z.number().optional().nullable(),
    fractionalOdds: oddsFractionSchema.optional().nullable(),
    liability: z.number().optional().nullable(),
    selections: z.array(trendingPickSelectionDtoSchema),
    bookAvailability: z.record(z.string(), trendingPickBookAvailabilityDtoSchema),
    user: trendingPickUserInfoSchema.optional().nullable(),
});
